import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#e8f7f4] border-t border-[#4db8a4]/20 py-12 mt-auto" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" data-id="element-41">
          <div className="md:col-span-1" data-id="element-42">
            <Link to="/" className="inline-block mb-4" data-id="element-43">
              <span className="text-xl font-bold tracking-tight text-[#1e3a5f]" data-id="element-44">
                MCPGuard
              </span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed" data-id="element-45">
              The security plane for enterprise agentic AI. Delegated
              authorization, full auditability, and deterministic control.
            </p>
          </div>

          <div data-id="element-46">
            <h3 className="text-sm font-bold text-[#1e3a5f] uppercase tracking-wider mb-4" data-id="element-47">
              Product
            </h3>
            <ul className="space-y-3" data-id="element-48">
              <li data-id="element-49">
                <Link to="/product" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-50">
                  Features
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/security" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-52">
                  Security & Audit
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/integrations" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-54">
                  Integrations
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/docs" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-56">
                  Documentation
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-57">
            <h3 className="text-sm font-bold text-[#1e3a5f] uppercase tracking-wider mb-4" data-id="element-58">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-59">
              <li data-id="element-60">
                <Link to="/about" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-61">
                  About Us
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/use-cases" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-63">
                  Use Cases
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/faq" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-65">
                  FAQ
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/early-access" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-67">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-68">
            <h3 className="text-sm font-bold text-[#1e3a5f] uppercase tracking-wider mb-4" data-id="element-69">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-70">
              <li data-id="element-71">
                <Link to="/privacy-policy" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-72">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/terms-of-service" className="text-sm text-gray-500 hover:text-[#4db8a4] transition-colors" data-id="element-74">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#4db8a4]/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-75">
          <p className="text-xs text-gray-400" data-id="element-76">
            &copy; {new Date().getFullYear()} ProvenanceOne. All rights
            reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-77">
            <a href="https://console.provenanceone.ai/" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-[#1e3a5f]" data-id="element-78">
              Console Login
            </a>
          </div>
        </div>
      </div>
    </footer>;
}